export * from '@primeuix/themes/lara/breadcrumb';
export { default } from '@primeuix/themes/lara/breadcrumb';
